// extracted by mini-css-extract-plugin
export default {"root":"rsH1K10F"};